import { render, staticRenderFns } from "./Pensioendetails.vue?vue&type=template&id=3f8817cb&"
import script from "./Pensioendetails.vue?vue&type=script&lang=ts&"
export * from "./Pensioendetails.vue?vue&type=script&lang=ts&"
import style0 from "./Pensioendetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports